function stack({ event, board, buttons, registerCleanup }) {
  const padding = parseFloat(getComputedStyle(board).gap);
  const startLeft = event.clientX - padding;
  const startTop = event.clientY - padding;


  board.classList.add("stack");
  buttons.forEach((button, i) => {
    const multiplyer = 7;
    button.style.transform = `translate(${startLeft - button.offsetLeft + (i * multiplyer)}px, ${startTop - button.offsetTop - board.offsetTop + (i * multiplyer)
      }px)`;
  });


  function cleanup() {
    board.classList.remove("stack");

    buttons.forEach((button) => {
      button.style.top = `initial`;
      button.style.left = `initial`;
      button.style.transform = `translate(0, 0)`;
    });
  }

  registerCleanup(cleanup);
}

export default stack;

